function noopFn() {}
const noop = noopFn as any;
export { noop }



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/utils/noop.ts